import clsx from "clsx";
import { ReactElement, ReactNode } from "react";

import { SelectNoneOptionLikeReactSelectStyled } from "./filter-multiselect.styled";

interface ISelectAllOptionProps {
  children: ReactNode;
  isFocused: boolean;
  isSelected: boolean;
  onFocus: (isSelected: boolean) => void;
}

export const SelectNoneOption = ({
  children,
  isFocused,
  isSelected,
  onFocus,
}: ISelectAllOptionProps): ReactElement => {
  return (
    <SelectNoneOptionLikeReactSelectStyled
      className={clsx({ isFocused, isSelected })}
      onMouseOver={() => onFocus(true)}
      onMouseLeave={() => onFocus(false)}
    >
      {children}
    </SelectNoneOptionLikeReactSelectStyled>
  );
};
